import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { AuthPasskeyLoginRequestBody, AuthPasskeyLoginResponse } from "./types";

export class AuthPasskeyLoginAPI extends BaseAPI<
  AuthPasskeyLoginRequestBody,
  AuthPasskeyLoginResponse
> {
  protected route = ApiRoutes.auth.passkey_login;
  protected method = RequestMethod.POST;
}
